export class AcessoResulthLocalConnectStruct {
  idAcessoResulthLocalConnect: number | null;
  idEmpresa: number | null;
  token: string | null;
  hostBDResulthLocal: string | null;
  portaBDResulthLocal: number | null;
  caminhoBDResulthLocal: string | null;
  usuarioBDResulthLocal: string | null;
  senhaBDResulthLocal: string | null;
  codFilialBDResulthLocal: string | null;
  datetimeInclusao: Date | null;
  utilizaTokenMatriz?: boolean | null;
  quantidadeEmpresasUsandoTokenMatriz?: number | null;
  idEmpresasUsandoTokenMatriz?: number[] | null;
}
